/**
 * Typed cache keys for the users feature (Users RBAC + IDM Requests + IDM ACC mappings).
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 */
export const usersKeys = {
	all: ['users'] as const,
	users: { list: () => ['users'] as const },
	idmRequests: {
		all: ['idm-requests'] as const,
		list: (status: string | undefined) => ['idm-requests', status] as const,
		detail: (requestId: string) => ['idm-request', requestId] as const,
		audit: (requestId: string) => ['idm-audit-trail', requestId] as const,
	},
	idmAccMappings: { list: () => ['idm-acc-mappings'] as const },
}
